import { InformedConsent } from '@/modules/informedConsent/informedConsent.model';
import axios, { AxiosError } from 'axios';
import {
  ErrorApiResponse,
  SingleApiResponse,
  SuccessApiResponse
} from '@ianesthesie-kit/services';

export class InformedConsentService {
  private static readonly URl = '/bff/patient/informed-consent';

  public static fetchInformedConsent(): Promise<InformedConsent> {
    return axios
      .get<SingleApiResponse<InformedConsent>>(this.URl)
      .then((resp) => resp.data.data)
      .catch((err: AxiosError<ErrorApiResponse>) => {
        throw err.response?.data?.error || JSON.stringify(err);
      });
  }

  public static signInformedConsent(
    payload: InformedConsent['items']
  ): Promise<SuccessApiResponse> {
    return axios
      .post<SuccessApiResponse>(`${this.URl}/sign`, payload)
      .then((resp) => resp.data)
      .catch((err: AxiosError<ErrorApiResponse>) => {
        throw err.response?.data?.error || JSON.stringify(err);
      });
  }

  public static isPending(consent: InformedConsent | undefined) {
    return !!consent && !!consent.consentSent && !consent.consentSigned;
  }
}
